import CommonAPIService from './CommonHandler';

export class RanksAPIService {
  constructor() {
    this.search = '';
    this.CommonAPIService = new CommonAPIService();
  }

  getRanks(router) {
    const url = '/api/ranks';
    return this.CommonAPIService.getCall(url, '', router);
  }

  getRanksById(rank_id, router){
    const url = `/api/ranks/${rank_id}`
    return this.CommonAPIService.postCall(url, '', router)
  }

  getRanksToPoomsae(router) {
    const url = '/api/ranks/poomsae';
    return this.CommonAPIService.getCall(url, '', router);
  }

  getRanksToTechniques(router) {
    const url = '/api/ranks/techniques';
    return this.CommonAPIService.getCall(url, '', router);
  }

  addRank(rank, router) {
    const url = '/api/ranks';
    return this.CommonAPIService.postCall(url, rank, router);
  }

  updateRank(rank_id, rank, router) {
    const url = `/api/ranks/${rank_id}`;
    return this.CommonAPIService.putCall(url, rank, router);
  }

  deleteRank(rank_id, router) {
    const url = `/api/ranks/${rank_id}`;
    return this.CommonAPIService.deleteCall(url, '', router);
  }
}

export default RanksAPIService;
